import { motion } from "framer-motion";

const institutions = [
    { name: "SUNARP", logo: "https://images.seeklogo.com/logo-png/33/1/sunarp-logo-png_seeklogo-334508.png" }, // Reemplazar con tus rutas locales
    { name: "SBN", logo: "https://pbs.twimg.com/profile_images/1996579244336427008/2RBHTUNL_400x400.jpg" },
    { name: "CAP", logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTzmBc_TSX9MrPfUF7aVuDbUS8b1tCDXn015w&s" }, // Colegio de Arquitectos
    { name: "CIP", logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS2WQvtFsFl-gN0er39KZcETiJRNmc2Yaw6Ig&s" }, // Colegio de Ingenieros
    { name: "Municipalidad de Lima", logo: "https://yt3.googleusercontent.com/_K9BH7jLX5R3gn3bErE8HQp4IXoqAkDTTIpjMygdmWliAb2oGutl_7HAOWCGhX_Lcvw4qM9n=s900-c-k-c0x00ffffff-no-rj" },
    { name: "SJL", logo: "https://upload.wikimedia.org/wikipedia/commons/5/51/Escudo_SJL.png" }, // San Juan de Lurigancho
];

const LogoMarquee = () => {
    return (
        <div className="py-12 bg-gray-50/50 border-y border-gray-100 overflow-hidden">
            <div className="max-w-7xl mx-auto px-6 mb-6 text-center">
                <p className="text-sm font-bold text-gray-400 uppercase tracking-[0.2em]">
                    Instituciones
                </p>
            </div>

            <div className="relative flex overflow-x-hidden">
                {/* Contenedor de la animación */}
                <motion.div
                    className="flex whitespace-nowrap gap-16 items-center"
                    animate={{ x: ["0%", "-50%"] }} // Se mueve la mitad para un loop infinito perfecto
                    transition={{
                        ease: "linear",
                        duration: 25,
                        repeat: Infinity,
                    }}
                >
                    {/* Duplicamos la lista para que el loop no tenga cortes */}
                    {[...institutions, ...institutions].map((inst, index) => (
                        <div key={index} className="flex items-center gap-4 grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-300 cursor-default">
                            <img
                                src={inst.logo}
                                alt={inst.name}
                                className="h-10 md:h-14 w-auto object-contain"
                            />
                            <span className="text-gray-400 font-bold text-lg md:text-xl tracking-tighter">
                                {inst.name}
                            </span>
                        </div>
                    ))}
                </motion.div>

                {/* Gradientes laterales para suavizar la entrada/salida */}
                <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-white to-transparent z-10" />
                <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-white to-transparent z-10" />
            </div>
        </div>
    );
};

export default LogoMarquee;